export default "__VITE_ASSET__jnwomJGl__"